var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('app-primary', {
    scopedSlots: _vm._u([{
      key: "contentsHead",
      fn: function () {
        return [_c('sub-head-primary', {
          attrs: {
            "bg": "/images/sub/about/visual.jpg"
          },
          scopedSlots: _vm._u([{
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("회사소개")))];
            },
            proxy: true
          }])
        })];
      },
      proxy: true
    }])
  }, [_c('page-section-primary', {
    staticClass: "page-section--first",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "subtit",
      fn: function () {
        return [_vm._v("about")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_vm._v(_vm._s(_vm.$t("개요")))];
      },
      proxy: true
    }])
  }, [_c('u-tit-wrap-default', {
    staticClass: "tit-wrap--sm"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm line-height-15"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('company.tit'))
    }
  })])], 1), _c('txt-primary', [_vm._v(_vm._s(_vm.$t("company.txt")))]), _c('v-img', {
    staticClass: "mt-40px mt-md-50px mt-lg-60px rounded-lg",
    attrs: {
      "src": "/images/sub/about/about.jpg"
    }
  })], 1), _c('page-section-primary', {
    staticClass: "page-section--last page-section--vision",
    attrs: {
      "titWrapClass": "text-center"
    },
    scopedSlots: _vm._u([{
      key: "subtit",
      fn: function () {
        return [_vm._v("vision")];
      },
      proxy: true
    }, {
      key: "tit",
      fn: function () {
        return [_c('span', {
          staticClass: "white--text"
        }, [_vm._v(_vm._s(_vm.$t("비전")))])];
      },
      proxy: true
    }])
  }, [_c('v-row', {
    staticClass: "row--lg"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-20px pa-md-30px pa-lg-40px",
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "num-wrap"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm"
  }, [_vm._v("01")])], 1), _c('v-divider', {
    staticClass: "w-20px w-lg-30px my-18px my-lg-24px mx-auto"
  }), _c('txt-primary', {
    staticClass: "txt--lg text-center"
  }, [_c('p', {
    staticClass: "font-weight-extrabold grey--text text--darken-4"
  }, [_vm._v(_vm._s(_vm.$t("vision.num01")))]), _c('p', {
    staticClass: "mt-12px mt-lg-16px"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('vision.num01Txt'))
    }
  })])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-20px pa-md-30px pa-lg-40px h-md-100",
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "num-wrap"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm"
  }, [_vm._v("02")])], 1), _c('v-divider', {
    staticClass: "w-20px w-lg-30px my-18px my-lg-24px mx-auto"
  }), _c('txt-primary', {
    staticClass: "txt--lg text-center"
  }, [_c('p', {
    staticClass: "font-weight-extrabold grey--text text--darken-4"
  }, [_vm._v(_vm._s(_vm.$t("vision.num02")))]), _c('p', {
    staticClass: "mt-12px mt-lg-16px"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('vision.num02Txt'))
    }
  })])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-20px pa-md-30px pa-lg-40px h-md-100",
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "num-wrap"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm"
  }, [_vm._v("03")])], 1), _c('v-divider', {
    staticClass: "w-20px w-lg-30px my-18px my-lg-24px mx-auto"
  }), _c('txt-primary', {
    staticClass: "txt--lg text-center"
  }, [_c('p', {
    staticClass: "font-weight-extrabold grey--text text--darken-4"
  }, [_vm._v(_vm._s(_vm.$t("vision.num03")))]), _c('p', {
    staticClass: "mt-12px mt-lg-16px"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('vision.num03Txt'))
    }
  })])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('v-card', {
    staticClass: "pa-20px pa-md-30px pa-lg-40px",
    attrs: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "num-wrap"
  }, [_c('u-tit-default', {
    staticClass: "tit--sm"
  }, [_vm._v("04")])], 1), _c('v-divider', {
    staticClass: "w-20px w-lg-30px my-18px my-lg-24px mx-auto"
  }), _c('txt-primary', {
    staticClass: "txt--lg text-center"
  }, [_c('p', {
    staticClass: "font-weight-extrabold grey--text text--darken-4"
  }, [_vm._v(_vm._s(_vm.$t("vision.num04")))]), _c('p', {
    staticClass: "mt-12px mt-lg-16px"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('vision.num04Txt'))
    }
  })])])], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }